import React from "react";
import {
  Box,
  Container,
  Grid,
  VStack,
  HStack,
  Heading,
  Link,
  Text,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import {
  FaLinkedin,
  FaYoutube,
  FaEnvelope,
  FaWhatsapp,
} from "react-icons/fa";

export default function Footer() {
  const disciplines = [
    { id: "full-stack-ai", name: "Full-Stack & AI Engineering" },
    { id: "mobile-dev", name: "Mobile Development" },
    { id: "data-science", name: "Data Science & Analytics" },
    { id: "cybersecurity", name: "Cybersecurity" },
    { id: "devops-sre", name: "DevOps / SRE" },
    { id: "digital-marketing", name: "Advanced Digital Marketing" },
  ];

  return (
    <Box bg="#0F172A" color="#FFFFFF" py={16}>
      <Container maxW="container.xl">
        <Grid
          templateColumns={{ base: "1fr", md: "repeat(4, 1fr)" }}
          gap={8}
          mb={12}
        >
          {/* About */}
          <VStack align="start" spacing={4}>
            <Heading size="md" color="#FFFFFF" fontFamily="Merriweather, serif">
              Ojasa Mirai
            </Heading>
            <Text fontSize="sm" color="#E2E8F0">
              Bridging academic learning with industry-ready careers for college students.
            </Text>
          </VStack>

          {/* Quick Links */}
          <VStack align="start" spacing={3}>
            <Heading size="sm" color="#FFFFFF">
              Quick Links
            </Heading>
            <Link as={RouterLink} to="/" fontSize="sm" color="#E2E8F0" _hover={{ color: "#10B981" }}>
              Home
            </Link>
            <Link as={RouterLink} to="/for-students" fontSize="sm" color="#E2E8F0" _hover={{ color: "#10B981" }}>
              For Students
            </Link>
            <Link as={RouterLink} to="/for-colleges" fontSize="sm" color="#E2E8F0" _hover={{ color: "#10B981" }}>
              For Colleges
            </Link>
            <Link as={RouterLink} to="/contact" fontSize="sm" color="#E2E8F0" _hover={{ color: "#10B981" }}>
              Contact
            </Link>
          </VStack>

          {/* Disciplines */}
          <VStack align="start" spacing={3}>
            <Heading size="sm" color="#FFFFFF">
              Disciplines
            </Heading>
            {disciplines.slice(0, 3).map((disc) => (
              <Link
                key={disc.id}
                as={RouterLink}
                to={`/disciplines/${disc.id}`}
                fontSize="sm"
                color="#E2E8F0"
                _hover={{ color: "#10B981" }}
              >
                {disc.name}
              </Link>
            ))}
          </VStack>

          {/* Connect */}
          <VStack align="start" spacing={4}>
            <Heading size="sm" color="#FFFFFF">
              Connect With Us
            </Heading>
            <HStack spacing={4}>
              <Link
                href="https://linkedin.com"
                isExternal
                color="#E2E8F0"
                _hover={{ color: "#10B981" }}
              >
                <FaLinkedin size={20} />
              </Link>
              <Link
                href="https://youtube.com"
                isExternal
                color="#E2E8F0"
                _hover={{ color: "#10B981" }}
              >
                <FaYoutube size={20} />
              </Link>
              <Link
                href="mailto:hello@ojasamirai.com"
                color="#E2E8F0"
                _hover={{ color: "#10B981" }}
              >
                <FaEnvelope size={20} />
              </Link>
              <Link
                href="https://wa.me/919876543210"
                isExternal
                color="#E2E8F0"
                _hover={{ color: "#10B981" }}
              >
                <FaWhatsapp size={20} />
              </Link>
            </HStack>
            <Text fontSize="xs" color="#94A3B8" mt={4}>
              hello@ojasamirai.com
            </Text>
          </VStack>
        </Grid>

        {/* Bottom Bar */}
        <Box borderTopWidth="1px" borderTopColor="#1E293B" pt={8}>
          <HStack justify="space-between" flexWrap="wrap" spacing={4}>
            <Text fontSize="sm" color="#94A3B8">
              © 2024 Ojasa Mirai. All rights reserved.
            </Text>
            <HStack spacing={6}>
              <Link href="#" fontSize="sm" color="#94A3B8" _hover={{ color: "#10B981" }}>
                Privacy Policy
              </Link>
              <Link href="#" fontSize="sm" color="#94A3B8" _hover={{ color: "#10B981" }}>
                Terms of Service
              </Link>
            </HStack>
          </HStack>
        </Box>
      </Container>
    </Box>
  );
}
